export const toHome = () => "/home";
export const toWork = () => "/portfolio";
export const toSkills = () => "/skills";
export const toAbout = () => "/about";